import { AdDetails } from '@/api/types/ads.types';
import { useAdDetails } from '@/views/Ads/useAdDetails';

export function useIsShop(initialAdDetails?: AdDetails | null) {
  const { adDetails } = useAdDetails();
  const { shop } = adDetails ?? initialAdDetails ?? {};

  return !!shop;
}
